import { useMemo } from 'react';

import { useGET } from '../shared/hooks';

const toUrl = leagueId => {
  let url = '/seasons?ordering=-name&limit=1000';
  if (leagueId) url += `&stages__league=${leagueId}`;
  return url;
};

export function useSeasons(league) {
  const url = league ? toUrl(league.id) : toUrl(null);
  const data = useGET(url);

  return useMemo(() => data && data.results, [data]);
}
